var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "el-select",
        _vm._g(
          _vm._b(
            {
              ref: "visualSelect",
              class: _vm.classId,
              attrs: {
                "popper-class": "VisualSelects coustom-de-select",
                "no-match-text": " ",
                clearable: "",
              },
              on: { change: _vm.visualChange, "visible-change": _vm.popChange },
              model: {
                value: _vm.selectValue,
                callback: function ($$v) {
                  _vm.selectValue = $$v
                },
                expression: "selectValue",
              },
            },
            "el-select",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _vm.startIndex === 0 && _vm.$attrs.multiple
            ? _c(
                "p",
                { staticClass: "select-all" },
                [
                  _c(
                    "el-checkbox",
                    {
                      directives: [
                        {
                          name: "customStyle",
                          rawName: "v-customStyle",
                          value: _vm.customStyle,
                          expression: "customStyle",
                        },
                      ],
                      attrs: { indeterminate: _vm.isIndeterminate },
                      on: { change: _vm.selectAllChange },
                      model: {
                        value: _vm.selectAll,
                        callback: function ($$v) {
                          _vm.selectAll = $$v
                        },
                        expression: "selectAll",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("dataset.check_all")) + "\n    ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._l(_vm.options, function (item) {
            return _c(
              "el-option",
              {
                key: item.id,
                class: _vm.setSelect(item.id),
                attrs: { label: item.text, value: item.id },
              },
              [
                _c("span", { attrs: { title: item.text } }, [
                  _vm._v(_vm._s(item.text)),
                ]),
              ]
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }